import axios from 'axios';
import { getAuthHeaders } from '../utils/authUtils';

class GlossaryService {
    constructor() {
        this.baseUrl = `${process.env.REACT_APP_API_URL}/api/v3/glossary`;
    }

    async generateGlossary(videoId, sourceLanguage, targetLanguage, subfolder) {
        const headers = getAuthHeaders(true);
        const payload = {
            videoId,
            sourceLanguage,
            targetLanguage,
            subfolder,
        };

        const response = await axios.post(`${this.baseUrl}/generate`, payload, { headers });
        return response.data;
    }

    async listGlossaries() {
        const headers = getAuthHeaders(true);
        const response = await axios.get(this.baseUrl, { headers });
        return response.data;
    }

    async getGlossary(filename, subfolder) {
        const headers = getAuthHeaders(true);
        const response = await axios.get(`${this.baseUrl}/${encodeURIComponent(filename)}?subfolder=${encodeURIComponent(subfolder || '')}`, {
            headers,
        });
        return response.data;
    }

    async saveGlossary(filename, subfolder, terms, expectedVersion = null) {
        const headers = getAuthHeaders(true);
        const response = await axios.put(
            `${this.baseUrl}/${encodeURIComponent(filename)}`,
            {
                filename,
                subfolder,
                expectedVersion,
                terms,
            },
            { headers },
        );
        return response.data;
    }

    /**
     * Submit staged changes for review.
     * changes: { [source]: { operation: 'add'|'update'|'delete', target, previousTarget } }
     * Any authenticated user may call this.
     */
    async submitPending(filename, subfolder, changes) {
        const headers = getAuthHeaders(true);
        const response = await axios.post(
            `${this.baseUrl}/${encodeURIComponent(filename)}/pending`,
            { subfolder, changes },
            { headers },
        );
        return response.data;
    }

    /**
     * Fetch all pending (staged) changes for a glossary.
     * Restricted to glossary managers and admins.
     */
    async getPending(filename, subfolder) {
        const headers = getAuthHeaders(true);
        const response = await axios.get(
            `${this.baseUrl}/${encodeURIComponent(filename)}/pending?subfolder=${encodeURIComponent(subfolder || '')}`,
            { headers },
        );
        return response.data;
    }

    /**
     * Approve and/or reject staged changes.
     * approved: { [sourceWord]: proposalIndex } — the chosen proposal per word is applied; all other proposals for that word are discarded.
     * rejected: string[] of source words — all proposals for those words are discarded without applying.
     * Restricted to glossary managers and admins.
     */
    async approvePending(filename, subfolder, approved, rejected) {
        const headers = getAuthHeaders(true);
        const response = await axios.post(
            `${this.baseUrl}/${encodeURIComponent(filename)}/approve`,
            { subfolder, approved, rejected },
            { headers },
        );
        return response.data;
    }
}

const glossaryServiceInstance = new GlossaryService();
export default glossaryServiceInstance;
